import { useCallback, useEffect, useState } from "react";
import { listarCoordenadoresDaCoordenacao } from "../api/coordenacoes";

// Busca os coordenadores da coordenação informada. Refetcha quando o id muda
// ou quando alguém dispara o evento `coordenacao:coordenadores-changed`
// (útil ao vincular/desvincular coord para refletir nas telas de turma).
export function useCoordenadoresDaCoordenacao(coordenacaoId) {
  const [coordenadores, setCoordenadores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(null);

  const carregar = useCallback(async () => {
    if (!coordenacaoId) {
      setCoordenadores([]);
      return;
    }
    setLoading(true);
    setErro(null);
    try {
      const lista = await listarCoordenadoresDaCoordenacao(coordenacaoId);
      setCoordenadores(Array.isArray(lista) ? lista : []);
    } catch (e) {
      setErro(e);
      setCoordenadores([]);
    } finally {
      setLoading(false);
    }
  }, [coordenacaoId]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  useEffect(() => {
    const handler = () => carregar();
    window.addEventListener("coordenacao:coordenadores-changed", handler);
    return () => window.removeEventListener(
      "coordenacao:coordenadores-changed", handler);
  }, [carregar]);

  return { coordenadores, loading, erro, recarregar: carregar };
}
